<template>
  <div style="background-color: #ececec; padding: 20px;">
    <a-row :gutter="16">
      <a-col :span="8">
        <a-card title="没有微信小程序" :bordered="false">
          <a href="https://mp.weixin.qq.com/" target="_blank">立即申请</a>
          <!-- <p><a-button type="primary" @click="openUrl()">立即申请</a-button></p> -->
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card title="已有小程序" :bordered="false">
          <a :href="goto_auth_url" target="_blank">立即绑定</a>
          <!-- <p><a-button type="primary">立即绑定</a-button></p> -->
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import { mixinDevice } from '@/utils/mixin.js'
  import {gotoAuthUrl} from '@/api/api';
  const directionType = {
    horizontal: 'horizontal',
    vertical: 'vertical'
  }

  export default {
    name: "registAuth",
    components: {},
    mixins: [mixinDevice],
    data () {
      return {
        title: '提交成功',
        goto_auth_url:"",
        directionType
      }
    },
    
    created() {
      this.getUrl();
    },
    methods:{
      getUrl() {
        let param={
          "saasCode":"0000",
          "host":"https://www.elinkx.com.cn:48443/",
          "authType":2
        }
      
        gotoAuthUrl(param).then((res)=>{
          if(res.success){
            this.goto_auth_url = res.result.url;
          console.log(res);
          }

        })
      }
    }

  }
</script>

<style scoped>

</style>